export const DefaultWorkDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'] as const;
export const WeekDays = ['sunday', ...DefaultWorkDays, 'saturday'] as const;
export type WeekDay = typeof WeekDays[number];
export type IWorkDaysSchema = { [weekDay in WeekDay]: boolean };

export interface IStartEndTimeWindowSchema {
    start: string; // format 'HH:mm'
    end: string; // format 'HH:mm'
}

export type IAvailabilityWindowSchema = { [weekDay in WeekDay]: IStartEndTimeWindowSchema[] };

/**
 * `all-internal-users-collective` - overlap availability of all
 * internal users invited to the meeting, **including** meeting organizer
 *
 * `all-internal-users-collective-no-organizer` - overlap availability of all
 * internal users invited to the meeting, **excluding** meeting organizer
 *
 * `some-internal-users-collective` - overlap availability of the users specified
 * in `availabilityUserIds`, may **include** or **exclude** meeting organizer
 *
 * `all-internal-users-round-robin` - flatten availability of all
 * internal users invited to the meeting, **including** meeting organizer.
 * Note: the ownership of the meeting will be **transfered** to one of the user's whose
 * availability was chosen.
 *
 * `all-internal-users-round-robin-no-organizer` - flatten availability of all
 * internal users invited to the meeting, **excluding** meeting organizer
 * Note: the ownership of the meeting will be **transfered** to one of the user's whose
 * availability was chosen.
 *
 * `some-internal-users-round-robin` - flatten availability of the users specified
 * in `availabilityUserIds`, may **include** or **exclude** meeting organizer.
 * Note: the ownership of the meeting will be **transfered** to one of the user's whose
 * availability was chosen.
 * if organizer is excluded this acts as ***On-behalf of***.
 */
export type AvailabilityType =
    | 'all-internal-users-collective'
    | 'all-internal-users-collective-no-organizer'
    | 'some-internal-users-collective'

    // round-robin
    | 'all-internal-users-round-robin' // future
    | 'all-internal-users-round-robin-no-organizer' // future
    | 'some-internal-users-round-robin'

    // on-behalf
    | 'on-behalf'
    | 'external-on-behalf';

// 'collective' represents all collective availability types, same with 'round-robin'
export type ExpandedAvailabilityType = AvailabilityType | 'collective' | 'round-robin';

// Availability types that rely on availabilityUserIds
export type AvailabilityTypesWithUserList = 'on-behalf' | 'collective' | 'round-robin';

export type AvailabilityPattern = 'book-over-internal-meetings';
